module.exports = __webpack_public_path__ + "static/img/411.b22e121d.jpg";